module.exports = __webpack_public_path__ + "static/img/24.6e3b48fe.jpg";